import styles from './CompleteStudentPage.module.css';

import IconAndName from '../../components/IconAndName/IconAndName';

import { useState } from 'react';

import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { IoAddCircleOutline } from 'react-icons/io5';
import CopyRight from '../../components/CopyRight/CopyRight';

import Profile from '../StudentDetailPages/Profile/Profile';
import Programs from '../StudentDetailPages/Programs/Programs';
import Attendance from '../StudentDetailPages/Attendance/Attendance';
import Billing from '../StudentDetailPages/Billing/Billing';
import TimeLine from '../StudentDetailPages/TimeLine/TimeLine';
import Notes from '../StudentDetailPages/Notes/Notes';
import Forms from '../StudentDetailPages/Forms/Forms';
import Gallery from '../StudentDetailPages/Gallery/Gallery';
import Immunization from '../StudentDetailPages/Immunization/Immunization';
import Progress from '../StudentDetailPages/Progress/Progress';
import Documents from '../StudentDetailPages/Documents/Documents';
import ThreeDotMenu from '../../components/ThreeDotMenu/ThreeDotMenu';

const CompleteStudentPage = () => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState('Profile');

  const tab = [
    {
      label: 'Profile',
      content: <Profile />,
    },
    {
      label: 'Programs',
      content: <Programs />,
    },
    {
      label: 'Attendance',
      content: <Attendance />,
    },
    {
      label: 'Billing',
      content: <Billing />,
    },
    {
      label: 'Timeline',
      content: <TimeLine />,
    },
    {
      label: 'Documents',
      content: <Documents />,
    },
    {
      label: 'Notes',
      content: <Notes />,
    },
    {
      label: 'Forms',
      content: <Forms />,
    },
    {
      label: 'Gallery',
      content: <Gallery />,
    },
    {
      label: 'Immunization',
      content: <Immunization />,
    },
    {
      label: 'Progress',
      content: <Progress />,
    },
  ];

  const actionsMenu = [
    {
      label: 'Student Logs',
      onClick: () =>
        dispatch(
          openModal({
            type: 'changeLogs',
            data: [
              {
                action: 'STUDENT ADDED',
                timestamp: '25 May 2025, 8:49 AM',
                name: '',
                updatedBy: 'Narasimha',
              },
              {
                action: 'STUDENT ADDED',
                timestamp: '25 May 2025, 8:49 AM',
                name: '',
                updatedBy: 'Narasimha',
              },
            ],
          })
        ),
    },
    {
      label: 'Delete Student',
      onClick: () => dispatch(openModal('delete')),
    },
    {
      label: 'Post Activity',
      onClick: () => dispatch(openModal('postActivity')),
    },
    {
      label: 'Transfer Student',
      onClick: () => dispatch(openModal('TransferStudent')),
    },
    { label: 'Kiosk QR', onClick: () => dispatch(openModal('QRCode')) },
  ];

  return (
    <>
      <div className={styles.background}>
        {/* Buttons specific to tabs */}
        {activeTab === 'Profile' && (
          <div className={styles.buttonRow}>
            <ThreeDotMenu options={actionsMenu} />
          </div>
        )}
        {activeTab === 'Notes' && (
          <div className={styles.buttonRow}>
            <IconAndName
              icon={<IoAddCircleOutline />}
              title="Add Note"
              bgColor="Primary_Color"
              onClick={() => dispatch(openModal('addNote'))}
            />
          </div>
        )}

        {activeTab === 'Documents' && (
          <div className={styles.buttonRow}>
            <div className={styles.buttons}>
              <IconAndName
                title="Add Folder"
                bgColor="Primary_Color"
                onClick={() => dispatch(openModal('addFolder'))}
              />
            </div>
            <div>
              <IconAndName
                icon={<IoAddCircleOutline />}
                title="Add document"
                bgColor="Primary_Color"
                onClick={() => dispatch(openModal('addDocument'))}
              />
            </div>
          </div>
        )}

        {activeTab === 'Immunization' && (
          <div className={styles.buttonRow}>
            <IconAndName
              title="Send remainder"
              bgColor="Primary_Color"
              onClick={() => dispatch(openModal('sendRemainder'))}
            />
          </div>
        )}

        {/* Main content section */}
        <div className={styles.StudentSection}>
          <div className={styles.maincontainer}>
            <div className={styles.container}>
              {tab.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`${styles.tabOptions} ${
                      activeTab === item.label && styles.ActivetabOption
                    }`}
                    onClick={() => setActiveTab(item.label)}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
          </div>

          {tab.map((item) =>
            activeTab === item.label ? (
              <div className={styles.tabContentContainer}>{item.content}</div>
            ) : null
          )}
        </div>
      </div>

      <div>{<CopyRight />}</div>
    </>
  ); // ✅ This was missing
};
export default CompleteStudentPage;
